module.exports = __webpack_public_path__ + "static/29import-a1cb8ad97d0e45010c7e742935b00816.png";